import React, { createContext, useContext, useState, useEffect } from 'react';

const CurrencyContext = createContext();

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};

export const CurrencyProvider = ({ children }) => {
  const [userCountry, setUserCountry] = useState(null); // ✅ no default IN
  const [exchangeRate, setExchangeRate] = useState(90);
  const [loading, setLoading] = useState(true);

useEffect(() => {
  const fetchWithTimeout = async (url, timeout = 4000) => {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    try {
      const res = await fetch(url, { signal: controller.signal });
      clearTimeout(id);

      if (!res.ok) throw new Error(`Failed: ${res.status}`);

      return await res.json();
    } catch (err) {
      clearTimeout(id);
      throw err;
    }
  };

  const detectUserCountry = async () => {
    const apis = [
      async () => {
        const data = await fetchWithTimeout('https://ipwho.is/');
        return data.country_code;
      },
      async () => {
        const data = await fetchWithTimeout('https://ipapi.co/json/');
        return data.country_code;
      },
      async () => {
        const data = await fetchWithTimeout('https://ipinfo.io/json');
        return data.country;
      }
    ];

    try {
      let country = null;

      for (const api of apis) {
        try {
          country = await api();
          if (country) break;
        } catch (e) {
          console.warn('API failed, trying next...');
        }
      }

      setUserCountry(country || 'US');

    } catch (error) {
      console.error('All country APIs failed:', error);
      setUserCountry('US');
    } finally {
      setLoading(false);
    }
  };

  detectUserCountry();
}, []);


  const value = {
    userCountry,
    exchangeRate,
    loading,
    isIndia: userCountry === 'IN'
  };

  // ✅ wait until country detected
  if (loading) return null;

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};
